module.exports = __webpack_public_path__ + "static/app-28b1ad373aab0a82ce0796a58c23b2be.svg";